import AppUtils from "@src/utils/appUtils";
import SignolUtils from "@src/utils/signolUtils";
import {
  aviationFormattedNotifications,
  shippingFormattedNotifications,
} from "./operatorObjectMocks/shared/getNotifications";

export function getOperatorProfile() {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingProfile;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationProfile;
            },
          );
      resolve(data);
    }, 10);
  });
}

export function getOperatorBaselines(industry) {
  const isShipping = !!industry
    ? industry === "shipping"
    : SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingBaselines;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationBaselines;
            },
          );
      resolve(data);
    }, 10);
  });
}
export function getEvents(from, to, _, industry) {
  const isShipping = !!industry
    ? industry === "shipping"
    : SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/shipevents").then(
            (response) => {
              return response.shipEvents;
            },
          )
        : await import("./operatorObjectMocks/aviation/flightEvents").then(
            (response) => {
              return response.aviationEvents;
            },
          );
      resolve({
        events: data.filter(
          (event) =>
            event.ocurrenceDatetime > from && event.ocurrenceDatetime < to,
        ),
      });
    }, 10);
  });
}
export function getImpact(_, industry) {
  const isShipping = !!industry
    ? industry === "shipping"
    : SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingImpact;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationImpact;
            },
          );
      resolve(data);
    }, 10);
  });
}
export function getExclusions() {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingExclusions;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationExclusions;
            },
          );
      resolve(data);
    }, 10);
  });
}
export function getCustomerCommitments() {
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data =
        await import("./operatorObjectMocks/shared/commitmentsResp").then(
          (response) => {
            return { customerCommitments: response.commitments };
          },
        );
      console.log(data);
      resolve(data);
    }, 10);
  });
}
export function getBaselines() {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingBaselines;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationBaselines;
            },
          );
      resolve(data);
    }, 10);
  });
}

export function getGoalSummaries(_, industry) {
  const isShipping =
    industry === "shipping" || SignolUtils.getIndustry() === "shipping";

  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingGoalSummaries;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationGoalSummaries;
            },
          );
      resolve(data);
    }, 10);
  });
}

export function getLatestEvents(limit) {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/overviewResp").then(
            (response) => {
              return response.getLatestShippingEventsResp(limit);
            },
          )
        : await import("./operatorObjectMocks/aviation/overviewResp").then(
            (response) => {
              return response.getLatestAviationEventsResp(limit);
            },
          );
      resolve(data);
    }, 10);
  });
}

export function getBestEvent() {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/operatorServiceResp").then(
            (response) => {
              return response.shippingBestEvent;
            },
          )
        : await import("./operatorObjectMocks/aviation/operatorServiceResp").then(
            (response) => {
              return response.aviationBestEvent;
            },
          );
      resolve(data);
    }, 10);
  });
}

export function getIncompleteEvents(id, industry) {
  const isShipping =
    industry === "shipping" || SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/overviewResp").then(
            (response) => {
              return response.shippingEventsUpToToday;
            },
          )
        : await import("./operatorObjectMocks/aviation/overviewResp").then(
            (response) => {
              return response.aviationEventsUpToToday;
            },
          );
      const selection = data.slice(1, 4);
      resolve({ events: selection });
    }, 10);
  });
}

export function saveSelfReport() {
  const response = {
    status: 200,
    ok: true,
    message: "Self report successfully saved",
  };
  return AppUtils.simulateResponse(response);
}

export function getEventById(_, eventId) {
  const isShipping = SignolUtils.getIndustry() === "shipping";
  return new Promise((resolve) => {
    setTimeout(async () => {
      const data = isShipping
        ? await import("./operatorObjectMocks/shipping/shipevents").then(
            (response) => {
              return response.shipEvents;
            },
          )
        : await import("./operatorObjectMocks/aviation/flightEvents").then(
            (response) => {
              return response.aviationEvents;
            },
          );
      const selectedResponse = data.filter((e) => e.id === eventId)[0];

      resolve({ event: selectedResponse });
    }, 10);
  });
}

export function updateEventComment() {
  const response = { status: 200, ok: true, comment: { id: "HJGJHGJHGJHG" } };
  return AppUtils.simulateResponse(response);
}

export function submitProfileUpdate() {
  const response = null;
  return AppUtils.simulateResponse(response);
}

export function readNotification(data) {
  return AppUtils.simulateResponse({ data: data.notificationId });
}

export function getNotifications(args) {
  const { industry } = args;
  const isShipping = industry
    ? industry === "shipping"
    : SignolUtils.getIndustry() === "shipping";

  const notifications = isShipping
    ? [...shippingFormattedNotifications]
    : [...aviationFormattedNotifications];

  return AppUtils.simulateResponse({ data: notifications });
}

export function operatorProfileLink(args) {
  return AppUtils.simulateResponse({});
}
